import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import axios from "axios";

const PostMalPracticeDialog = ({
  open,
  onClose,
  examScheduleMasterId,
  timetableId,
  program_name,
  slot_description,
  from_exam_date,
  showSnackbar,
}) => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const clientId = user?.client_id;
  const collegeId = user?.college_id;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [barcodeValue, setBarcodeValue] = useState("");
  const [studentRollNo, setStudentRollNo] = useState("");
  const [students, setStudents] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const fetchStudent = async (type, value) => {
    if (!value) return;
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/exam-halltickets/${clientId}/${collegeId}/${examScheduleMasterId}/${timetableId}?type=${type}&value=${value}`
      );
      if (res.data.success && res.data.data) {
        const studentsArray = Array.isArray(res.data.data) ? res.data.data : [res.data.data];

        setStudents(studentsArray);
      } else {
        setStudents([]);
        showSnackbar?.("No matching student found", "warning");
      }
    } catch (err) {
      console.error(err);
      showSnackbar?.("Error fetching student", "error");
    }
  };

  const handleMarkMalPractice = async (row) => {
    try {
      await axios.put(
        `${API_BASE_URL}/api/exam-halltickets/mark-malpractice/${clientId}/${collegeId}/${row.exam_barcode_id}`,
        { attendance: "MP" }
      );
      showSnackbar?.(`Marked ${row.student?.student_name || ""} as Mal Practice`, "success");
      setStudents((prev) =>
        prev.map((s) =>
          s.exam_barcode_id === row.exam_barcode_id ? { ...s, attendance: "MP" } : s
        )
      );
    } catch (err) {
      console.error(err);
      showSnackbar?.("Failed to mark Mal Practice", "error");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }

        onClose();
      }}
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>Post MalPractice Rollnos/Barcodes for {program_name || ""}</span>
          <span>{from_exam_date}</span>
          <span>{slot_description || ""}</span>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
          <TextField
            label="Scan Barcode"
            variant="outlined"
            fullWidth
            value={barcodeValue}
            onChange={(e) => setBarcodeValue(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && fetchStudent("barcode_value", barcodeValue)}
          />
          <TextField
            label="Enter Roll No"
            variant="outlined"
            fullWidth
            value={studentRollNo}
            onChange={(e) => setStudentRollNo(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && fetchStudent("student_rollno", studentRollNo)}
          />
        </Box>
        <Box
          sx={{
            width: "100%",
            overflowX: "auto", // horizontal scroll
            mt: 2,
          }}
        >
          <Box sx={{ minWidth: 450 }}>
            <DataGrid
              rows={students.map((s, index) => ({
                id: index + 1,
                sno: index + 1, // S.No
                ...s,
                student_name: s.student?.student_name,
                student_rollno: s.student?.student_rollno,
              }))}
              columns={[
                { field: "sno", headerName: "S.No", flex: 0.3 },
                { field: "student_rollno", headerName: "Roll No", flex: 1 },
                { field: "student_name", headerName: "Student Name", flex: 2 },
                {
                  field: "attendance",
                  headerName: "Attendance",
                  flex: 1,
                  valueGetter: (params) => params.row.attendance || "",
                },
                {
                  field: "actions",
                  headerName: "Actions",
                  flex: 1,
                  renderCell: (params) => (
                    <Button
                      variant="contained"
                      color="error"
                      size="medium"
                      disabled={params.row.attendance === "MP"}
                      onClick={() => handleMarkMalPractice(params.row)}
                    >
                      Mark MalPractice
                    </Button>
                  ),
                },
              ]}
              autoHeight
              pageSize={pageSize} // controlled pageSize
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} // update state
              rowsPerPageOptions={[5, 10, 25, 50]}
              disableRowSelectionOnClick
              pagination
              onCellClick={(params, event) => event.stopPropagation()} // block cell clicks
              onRowClick={(params, event) => event.stopPropagation()} // block row clicks
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            "&:hover": { backgroundColor: "#1565c0" },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PostMalPracticeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  examScheduleMasterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  timetableId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  program_name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  slot_description: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  from_exam_date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showSnackbar: PropTypes.func,
};

export default PostMalPracticeDialog;
